import { render, staticRenderFns } from "./ChangeWorkResultsApplication.vue?vue&type=template&id=c6234108"
import script from "./ChangeWorkResultsApplication.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeWorkResultsApplication.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports